// extracted by mini-css-extract-plugin
export var content = "features-module--content--0bEmk";
export var featureContainer = "features-module--featureContainer--RK3YM";
export var copyColumn = "features-module--copyColumn--stA-g";
export var copyContainer = "features-module--copyContainer--1eEoC";
export var secondaryText = "features-module--secondaryText--oVOmy";
export var primaryText = "features-module--primaryText--meLzA";
export var imageColumn = "features-module--imageColumn--0LFbj";
export var contentContainer = "features-module--contentContainer--ktJar";
export var reverse = "features-module--reverse--TA-fw";